// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'



// 车辆道闸开关
export function updateOfficeGateOne(data) {
  const url = global.requestUrl + '/equip/handleGate?operation=' + data.value + '&reason=' + data.reason
  return axios.get(url)
}

// 车辆道闸开关
export function updateMaterialGateOne(data) {
  const url = global.requestUrl + '/equip/handleWestGate?operation=' + data.value + '&reason=' + data.reason
  return axios.get(url)
}

// 获取货车道闸列表
export function getCarHistoryList(data) {
  const url = global.requestUrl + '/carAccessRecord/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

// 获取货车道闸列表
export function getTruckHistoryList(data) {
  const url = global.requestUrl + '/truckAccess/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&truckType=' + data.truckType + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

